var _cloneBuffer = {exports: {}};

export { _cloneBuffer as __module };
//# sourceMappingURL=_cloneBuffer.js.map
